export default "__VITE_ASSET__jcf5Kkux__"